<script setup lang="ts" generic="T">
import { ListboxButton } from '@headlessui/vue'

type Props = {
    label: string
}

const { label } = defineProps<Props>()
</script>

<template>
    <listbox-button
        class="relative w-full cursor-default rounded-md bg-white py-2 pl-4 pr-7 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-main sm:text-sm"
    >
        <span class="block truncate">{{ label }}</span>

        <i
            class="lni lni-chevron-down text-gray-500 font-black pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
            aria-hidden="true"
        ></i>
    </listbox-button>
</template>
